import actionCreatorFactory from 'typescript-fsa';

import { FormName } from '@topconagriculture/feed-types';

import reduxConfig from '../../config';
import { RecipeDuplicatePayload } from './recipes.types';

const actionCreator = actionCreatorFactory(reduxConfig.appName + '/recipe');

export const getRecipeList = actionCreator.async<any, any>('[GET_RECIPE_LIST]');
export const getRecipe = actionCreator.async<any, any>('[GET_RECIPE]');

export const createRecipe = actionCreator.async<FormName, any>('[CREATE_RECIPE]');
export const editRecipe = actionCreator.async<FormName, any>('[EDIT_RECIPE]');
export const deleteRecipe = actionCreator.async<FormName, any>('[DELETE_RECIPE]');
export const renameRecipe = actionCreator.async<FormName, any>('[RENAME_RECIPE]');
export const duplicateRecipe = actionCreator.async<RecipeDuplicatePayload, any>('[DUPLICATE_RECIPE]');
